import { Navigation } from 'swiper/modules';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Slider from '../utils/slider.ts';
import API from '../api/index.ts';
import QueryParams from '../support/UrlQueryParam/index.ts';
import Pagination from '../support/Pagination/index.ts';
import tippy from 'tippy.js';

class DirectoryListing extends MainClass {
	private urlParamMethod;
	private apiFilterParams = {
		'sort-by': 'latest',
	};
	private isMobile = window.innerWidth < 992;
	private pageQueryKey = 'page_num';
	private searchQueryKey = 'search_keyword';
	private taxonomySearchData = {};
	private pagination;
	private controller: AbortController | null = null;
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.urlParamMethod = new QueryParams();
		this.pagination = new Pagination()
		this.init();
	}

	getDataDropdownSearch = () => {
		const dropdownsListELe = this.selector.querySelector( '.inner-dropdown-list ul' ) as HTMLElement;
		const data = dropdownsListELe.getAttribute( 'data-taxo' );
		if ( data ) {
			this.taxonomySearchData = JSON.parse( atob( data ) );
			dropdownsListELe.removeAttribute( 'data-taxo' );
		}
	};

	clearFilterParams( queryName ) {
		delete this.apiFilterParams[ queryName ];
		this.urlParamMethod.pushQueryParamsToUrl( queryName, '' );
	}

	handleClickPagination = page => {
		this.urlParamMethod.pushQueryParamsToUrl( this.pageQueryKey, page.toString() );
		if ( Object.keys( this.apiFilterParams ).includes( this.pageQueryKey ) ) {
			delete this.apiFilterParams[ this.pageQueryKey ];
		}
		this.apiFilterParams[ this.pageQueryKey ] = page;
		this.filterDirectory().then( () => {
			this.selector.scrollIntoView( {
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest',
			} );
		} );
	};

	handleExpandOptions = ( el: HTMLElement ) => {
		const toggleBtn = el.querySelector( '.toggle-btn' ) as HTMLElement;
		if ( ! toggleBtn ) {
			return;
		}
		const options = Array.from( el.querySelectorAll( '.option-item' ) ) as HTMLInputElement[];
		const toggleTextBtn = el.querySelector( '.toggle-btn .btn-text' ) as HTMLElement;
		const btnIcon = el.querySelector( '.toggle-btn img' ) as HTMLElement;
		let showMore = false;
		const visibleOptions = 5;

		toggleBtn.addEventListener( 'click', e => {
			e.preventDefault();
			showMore = ! showMore;
			if ( options?.length ) {
				options.forEach( ( option: HTMLInputElement, index: number ) => {
					option.style.display = index < visibleOptions || showMore ? 'flex' : 'none';
				} );
				toggleBtn.style.display = options.length > visibleOptions ? 'flex' : 'none';
				toggleTextBtn.textContent = showMore ? 'Show less' : 'Show all';
				btnIcon.classList.toggle( 'active' );
			}
		} );
	};

	handleCloseQuickView = () => {
		const bodyELe = document.body;
		const directoryQuickViewWrapper = this.selector.querySelector( '.raise-directory-quick-view' ) as HTMLElement;
		const triangleActive = this.selector.querySelector( '.triangle.active' ) as HTMLElement;
		const currentDirectoryActive = this.selector.querySelector( '.raise-directory-item.active' ) as HTMLElement;
		if ( currentDirectoryActive ) {
			currentDirectoryActive.classList.remove( 'active' );
		}
		if ( directoryQuickViewWrapper ) {
			const childElement = directoryQuickViewWrapper.children[ 0 ]; // or use querySelector to select the child element
			directoryQuickViewWrapper.classList.remove( 'active' );
			directoryQuickViewWrapper.removeChild( childElement );
		}
		if ( triangleActive ) {
			triangleActive.classList.remove( 'active' );
		}
		if ( bodyELe ) {
			bodyELe.classList.remove( 'overflow-hidden' );
		}
	};

	addEventCloseQuickView = () => {
		const closeQuickViewToggle = this.selector.querySelector( '.close-directory-quick-view-toggle' ) as HTMLElement;
		if ( closeQuickViewToggle ) {
			closeQuickViewToggle.addEventListener( 'click', this.handleCloseQuickView );
		}
	};
	private resetActiveTriangle() {
		const activeTriangle = this.selector.querySelector('.triangle.active') as HTMLElement;
		if (activeTriangle) {
			activeTriangle.classList.remove('active');
		}
	}

	private setQuickViewDetailPosition(currentItem: HTMLElement, detailElement: HTMLElement) {
		const offset = currentItem.getBoundingClientRect().top - detailElement.getBoundingClientRect().top;
		const top = Math.max(0, offset);
		detailElement.style.top = `${top}px`;
	}

	private setTrianglePosition(
		triangle: HTMLElement,
		currentItem: HTMLElement,
		isScrollToTop: boolean
	) {
		if (!triangle) return;
		triangle.style.opacity = '0';
		setTimeout(() => {
			const itemRect = currentItem.getBoundingClientRect();
			const triangleTop = isScrollToTop ? itemRect.top + 24 : 24;
			triangle.style.top = `${triangleTop}px`;
			triangle.style.opacity = '1';
		}, 500);
	}

	private handleChipToggle(wrapper: HTMLElement) {
		const chip = wrapper.querySelector('.raise-chip') as HTMLElement;
		if (chip && window.matchMedia('(max-width: 905px)').matches) {
			chip.addEventListener('click', () => chip.classList.toggle('active'));
		}
	}

	abortPreviousRequest() {
    if (this.controller) {
      this.controller.abort();
    }
  }

	getDirectoryInfo = async ( directoryId: string, currentItem: HTMLElement, isScrollToTop: boolean ) => {
		try {
					this.abortPreviousRequest();
					this.controller = new AbortController();
					const { signal } = this.controller;
					const apiMethod = new API( { feature: 'posts/v2' } );
					const response = await apiMethod.getApi( `wp/v2/directory/${ directoryId }`, { signal } );
					this.controller = null;
			if ( response ) {
				const directoryQuickView = this.selector.querySelector( '.raise-directory-quick-view' ) as HTMLElement;
				const bodyELe = document.body;
				if ( directoryQuickView && response?.meta_data?.template ) {
					directoryQuickView.innerHTML = response?.meta_data?.template;
					directoryQuickView.classList.add( 'active' );
					bodyELe.className = `${ bodyELe.className } overflow-hidden lg:overflow-visible`;


					// handle set position of triangle quick view
					// const listDirectoryWrapperELe = this.selector.querySelector( '.js-directory-list' ) as HTMLElement;
					const directoryQuickViewDetail = directoryQuickView.querySelector(
						'.directory-quick-view-detail',
					) as HTMLElement;
					const triangleEle = currentItem.querySelector( '.triangle' ) as HTMLElement;
					const currentTriangleActive = this.selector.querySelector( '.triangle.active' ) as HTMLElement;
					if ( currentTriangleActive ) {
						currentTriangleActive.classList.remove( 'active' );
					}
					if ( triangleEle ) {
						triangleEle.classList.add( 'active' );
					}

					if ( isScrollToTop ) {
						currentItem.scrollIntoView( {
							behavior: 'smooth',
							block: 'start',
							inline: 'nearest',
						} );
					}

					let top = currentItem.getBoundingClientRect().top - directoryQuickViewDetail.getBoundingClientRect().top;
					if (top < 0) {
						top = 0
					}
					directoryQuickViewDetail.style.position = `sticky`;


					const triangle = directoryQuickView.querySelector( '.triangle' ) as HTMLElement;
					triangle.style.opacity = "0";
					setTimeout( () => {
						const rect = currentItem.getBoundingClientRect();
						let triangleTop = rect.top + 24;
						if (!isScrollToTop) {
							triangleTop = 24;
						}
						triangle.style.top = `${triangleTop}px`;
						triangle.style.opacity = "1";
					}, 500)
					// handle show chip description in quick view on mobile
					const chip = directoryQuickView.querySelector( '.raise-chip' ) as HTMLElement;
					if ( chip && window.matchMedia( '(max-width: 905px)' ).matches ) {
						chip.addEventListener( 'click', () => chip.classList.toggle( 'active' ) );
					}
					window.addEventListener('scroll',function(){
						const topPosition = currentItem.getBoundingClientRect().top + currentItem.offsetHeight - 60;
						topPosition < 1 ? triangle.style.opacity = "0" : triangle.style.opacity = "1"
					})
					this.addEventCloseQuickView();
					tippy('[data-tippy-content]');
					this.initCarousel();
				}
			}
		} catch ( error ) {}
	};

	handleClickDirectoryItem = ( e: MouseEvent, currentItem: HTMLElement, isScrollToTop: boolean = true ) => {
		const target = e.target as HTMLElement;
		if ( target?.closest( '.raise-chip.has-tooltip' ) ) {
			if ( window.matchMedia( '(max-width: 992px)' ).matches ) {
				const chip = target.closest( '.raise-chip' ) as HTMLElement;
				chip && chip.classList.toggle( 'active' );
			}
		} else {
			const currentItemActive = this.selector.querySelector( '.raise-directory-item.active' ) as HTMLElement;
			currentItemActive && currentItemActive.classList.remove( 'active' );
			const directoryId = currentItem.dataset.id as string;
			currentItem.classList.add( 'active' );
			directoryId && this.getDirectoryInfo( directoryId, currentItem, isScrollToTop );
		}
	};

	handleOpenTagFilter = () => {
		const tagDropdown = this.selector.querySelector( '.tag-dropdown' ) as HTMLElement;
		if ( tagDropdown ) {
			tagDropdown.classList.toggle( 'active' );
		}
	};

	initCarousel = () => {
		const carousel = new Slider(null);
		const directoryQuickViewImages = this.selector.querySelector(
			'.directory-listing-detail-image',
		) as HTMLElement;
		const slides = Array.from(
			directoryQuickViewImages.querySelectorAll( '.swiper-slide' ),
		) as HTMLElement[];
		if ( directoryQuickViewImages && carousel && slides?.length > 1) {
			carousel.initCarousel( directoryQuickViewImages, {
				slidesPerView: 1.3,
				spaceBetween: 8,
				modules: [ Navigation ],
				navigation: {
					nextEl: '.directory-listing-detail-image .swiper-button-next',
					prevEl: '.directory-listing-detail-image .swiper-button-prev',
				},
			} );
		}
	};

	activeFilter = (form: HTMLFormElement) => {
		const ParamKeys = this.urlParamMethod.getAllParamKeys();
		const urlFilterParams = ParamKeys.map( item => ( { [ item ]: this.urlParamMethod.getUrlParameter( item ) } ) );
		this.apiFilterParams = Object.assign( {}, ...urlFilterParams );
		const flatArray = urlFilterParams?.reduce( ( acc, obj ) => {
			const values = Object.values( obj );
			return acc.concat( ...values );
		}, [] );
		const dropdownWrapper = Array.from(
			form.querySelectorAll( '.dropdown-wrapper, .raise-tag-toggle' ),
		) as HTMLElement[];
		const inputsByName = {};
		flatArray?.forEach( item => {
			const activeInput = this.selector.querySelector( `input[value="${ item }"]` ) || document.querySelector(`.js-search-wrapper input[value="${ item }"]`) as HTMLInputElement;
			if ( activeInput ) {
				activeInput.checked = true;
				activeInput.closest( '.dropdown-wrapper' )?.classList.add( 'active' );
				const inputName = activeInput.getAttribute( 'name' );
				const inputValue = activeInput.getAttribute( 'value' );
				if ( inputName ) {
					if ( ! inputsByName[ inputName ] ) {
						inputsByName[ inputName ] = [];
					}
					inputsByName[ inputName ].push( inputValue );
				}
			}
		} );
		this.apiFilterParams = { ...this.apiFilterParams, ...inputsByName };
		let activeList = this.handleGetActiveChipList( dropdownWrapper );
		this.handleRenderFilterChips( activeList );
	};

	clearAllActiveFilter = () => {
		const paramKeys = this.urlParamMethod.getAllParamKeys();
		const dropdownFilter = Array.from(
			this.selector.querySelectorAll( '.dropdown-wrapper.active' ),
		) as HTMLElement[];
		const chips = Array.from( this.selector.querySelectorAll( '.js-filter-chip ' ) ) as HTMLElement[];
		if ( dropdownFilter?.length ) {
			dropdownFilter.forEach( item => item.classList.remove( 'active' ) );
		}
		if ( chips ) {
			chips.forEach( item => item.remove() );
		}
		paramKeys?.length &&
		paramKeys.map( item => {
			const inputActive = this.selector.querySelector(
				`input[name="${ item }"]:checked`,
			) as HTMLInputElement;
			if ( inputActive ) {
				inputActive.checked = false;
			}
		} );
	};

	renderNoResult = ( wrapEle: HTMLElement ) => {
		const cardTemplate = this.selector.querySelector( '.no-result-template' ) as HTMLTemplateElement;
		wrapEle.innerHTML = cardTemplate.innerHTML;
	};

	handleShowQuickView = () => {
		const firstDirectory = this.selector.querySelector( '.raise-directory-item' ) as HTMLElement;
		if ( firstDirectory ) {
			this.handleClickDirectoryItem( new MouseEvent( 'click' ), firstDirectory, false );
		}
	};

	filterDirectory = async ( inputSearch?: string ) => {
		try {
			this.abortPreviousRequest();
			this.controller = new AbortController();
			const { signal } = this.controller;
			const quickViewActive = this.selector.querySelector( '.raise-directory-quick-view.active' ) as HTMLElement;
			if ( quickViewActive ) {
				quickViewActive.classList.remove( 'active' );
			}
			let searchMessage = '';
			if ( this.apiFilterParams[ this.searchQueryKey ] ) {
				searchMessage = `with <span class="text-primary text-body-b3-medium">‘${ this.apiFilterParams[ this.searchQueryKey ] }’</span>`;
			} else {
				this.clearFilterParams( this.searchQueryKey );
			}
			const dataFilter = new API( { feature: 'directory/v1' } );
			const response = await dataFilter.filter( 'directory/v1/filter', this.apiFilterParams, { signal } );
			this.controller = null;
			const directoryListWrapper = this.selector.querySelector( '.js-directory-list' ) as HTMLElement;
			const cardTemplate = this.selector.querySelector( '.card-template-skeleton' ) as HTMLTemplateElement;
			const listingCount = this.selector.querySelector( '.js-listing-count ' ) as HTMLElement;
			const currentPage = this.urlParamMethod.getUrlParameter( this.pageQueryKey )[ 0 ] || 1;
			const loadingTemplateNumber = response?.data?.length || 8;
			directoryListWrapper.innerHTML = '';
			listingCount.innerHTML = '';
			let memberShipType = 'Social Enterprises';
			if ( this.apiFilterParams[ 'member-ship' ] && this.apiFilterParams[ 'member-ship' ][ 0 ] === 'ric' ) {
				memberShipType = 'raiSE Impact Community social enterprises';
			}
			if ( cardTemplate && directoryListWrapper ) {
				for ( let i = 0; i < loadingTemplateNumber; i++ ) {
					directoryListWrapper.append( cardTemplate.content.cloneNode( true ) );
				}
			}
			if ( response?.data?.length > 0 ) {
				setTimeout( () => {
					directoryListWrapper.innerHTML = response.data?.map( ( item: any ) => item?.template ).join( '' );
					this.addEventClickDirectoryItem();
					tippy('[data-tippy-content]');
					if (window.matchMedia( '(min-width: 905px)' ).matches ) {
						this.handleShowQuickView();
					}
					listingCount.innerHTML = `Showing all ${ response?.total } ${ memberShipType } ${ searchMessage }`;
				}, 300 );
			} else {
				setTimeout( () => {
					this.renderNoResult( directoryListWrapper );
					listingCount.innerHTML = `Showing all 0 ${ memberShipType } ${ searchMessage }`;
				}, 300 );
			}
			this.pagination.renderPagination(
				Math.floor( response?.pagination || 0 ),
				currentPage,
				this.handleClickPagination,
			);
		} catch ( error ) {
			console.error( 'error', error );
		}
	};

	addEventClickDirectoryItem = () => {
		const directoryItems = Array.from( this.selector.querySelectorAll( '.raise-directory-item' ) ) as HTMLElement[];
		if ( directoryItems?.length ) {
			directoryItems.forEach( item => {
				item.addEventListener( 'click', ( e: MouseEvent ) => {
					this.handleClickDirectoryItem( e, item )
				} );
			} );
		}
	};

	handleRenderFilterChips = ( activeList: string[] ) => {
		if ( ! activeList?.length || this.isMobile ) {
			return;
		}
		const chipsContainer = this.selector.querySelector( '.js-chip-container' ) as HTMLElement;
		const template = this.selector.querySelector( '.js-chip-template' ) as HTMLTemplateElement;
		chipsContainer.innerHTML = '';
		activeList.forEach( item => {
			const chip = template.content.cloneNode( true ) as HTMLElement;
			const chipLabel = chip.querySelector( '.js-chip-label' ) as HTMLElement;
			chip.firstElementChild.setAttribute( 'data-name', Object.keys( item )?.[ 0 ] );
			chipLabel.innerText = item[ Object.keys( item )?.[ 0 ] ];
			chipsContainer.appendChild( chip );
		} );
		this.addEventForChips();
	};

	handleGetActiveChipList = (dropdownWrapper: HTMLElement[]) => {
		if ( ! dropdownWrapper?.length ) {
			return;
		}
		let activeList = [] as object[];
		dropdownWrapper.forEach( ( dropdown: HTMLElement ) => {
			let inputActive = dropdown.querySelector( 'input:checked' ) as HTMLElement;
			if ( ! inputActive ) {
				inputActive = dropdown?.closest( '.raise-tag-filter' )?.querySelector( 'input:checked' ) as HTMLElement;
			}
			if ( inputActive?.getAttribute( 'name' ) === dropdown.getAttribute( 'data-name' ) ) {
				if ( ! activeList.includes( dropdown?.getAttribute( 'data-label' ) ) ) {
					activeList = [
						...activeList,
						{
							[ dropdown.getAttribute( 'data-name' ) as string ]: dropdown.getAttribute(
								'data-label',
							) as string,
						},
					];
				}
			}
		} );
		return activeList;
	};

	handleOptionChange = ( form: HTMLFormElement ) => {
		const dropdownWrapper = Array.from(
			form.querySelectorAll( '.dropdown-wrapper, .raise-tag-toggle' ),
		) as HTMLElement[];
		let activeList = this.handleGetActiveChipList( dropdownWrapper );
		if ( dropdownWrapper?.length ) {
			dropdownWrapper.forEach( ( dropdown: HTMLElement ) => {
				let inputActive = dropdown.querySelector( 'input:checked' ) as HTMLElement;
				this.handleRenderFilterChips( activeList );
				if ( inputActive ) {
					dropdown.classList.add( 'active' );
				} else {
					dropdown.classList.remove( 'active' );
				}
			} );
		}

		const formData = new FormData( form );
		const values: Record< string, string[] > = {};
		for ( let [ name, value ] of formData.entries() ) {
			if ( typeof value === 'string' && value !== '' ) {
				if ( name in values ) {
					values[ name ].push( value );
				} else {
					values[ name ] = [ value ];
				}
				this.apiFilterParams = { ...this.apiFilterParams, ...values };
				this.urlParamMethod.pushQueryParamsToUrl( name, values[ name ] );
			}
		}
		this.clearFilterParams( this.pageQueryKey );
		if ( ! this.isMobile ) {
			this.filterDirectory();
		}
	};

	handleOpenFilterPopupMobile = ( classElement: string ) => {
		const mobilePopupFilter = this.selector.querySelector( `.${ classElement }` ) as HTMLElement;
		if ( mobilePopupFilter ) {
			document.body.classList.add( 'overflow-hidden' );
			mobilePopupFilter.classList.add( 'active' );
			mobilePopupFilter.querySelector( '.js-side-bar-filter-form, .tag-dropdown' )?.classList.add( 'active' );
		}
	};

	activeFilterToggleMobile = () => {
		const filterLabel = this.selector.querySelector( '.mobile-filter-label' ) as HTMLElement;
		const sortLabel = this.selector.querySelector( '.mobile-sort-label' ) as HTMLElement;
		const allFilterParamKeys = this.urlParamMethod.getAllParamKeys();
		const restOfFilterParamKeys = allFilterParamKeys.filter( key => key !== 'sort-by' );
		if ( restOfFilterParamKeys?.length ) {
			filterLabel.classList.add( 'active' );
		} else {
			filterLabel.classList.remove( 'active' );
		}
		if ( allFilterParamKeys.includes( 'sort-by' ) ) {
			sortLabel.classList.add( 'active' );
		} else {
			sortLabel.classList.remove( 'active' );
		}
	};

	handleClosePopupFilterMobile = ( classElement: string ) => {
		document.body.classList.remove( 'overflow-hidden' );
		const mobilePopupFilter = this.selector.querySelector( `.${ classElement }` ) as HTMLElement;
		if ( mobilePopupFilter ) {
			mobilePopupFilter.classList.remove( 'active' );
			mobilePopupFilter.querySelector( '.js-side-bar-filter-form' )?.classList.remove( 'active' );
		}
		this.filterDirectory();
		this.activeFilterToggleMobile();
	};

	handleClearMobilePopupOption = ( event: Event ) => {
		event.preventDefault();
		const currentForm = event.target.closest( 'form' ) as HTMLFormElement;
		const activeInputs = Array.from( currentForm.querySelectorAll( 'input:checked' ) ) as HTMLInputElement[];
		activeInputs.forEach( input => {
			input.checked = false;
			this.apiFilterParams = { ...this.apiFilterParams, [ input.name ]: '' };
			this.urlParamMethod.pushQueryParamsToUrl( input.name, [] );
			this.activeFilterToggleMobile();
		} );
		this.handleOptionChange( currentForm );
	};
	clearFilterOptions = ( optionName: string ) => {
		const inputActive = Array.from(
			this.selector.querySelectorAll( `input[name="${ optionName }"]:checked` ),
		) as HTMLFormElement[];
		const currentDropdown = this.selector.querySelector(
			`.dropdown-wrapper[data-name="${ optionName }"]`,
		) as HTMLElement;
		currentDropdown?.classList.remove( 'active' );
		inputActive.forEach( input => {
			input.checked = false;
			this.apiFilterParams = { ...this.apiFilterParams, [ input.name ]: '' };
			this.urlParamMethod.pushQueryParamsToUrl( input.name, [] );
		} );
	};

	addEventForChips = () => {
		const chips = Array.from( this.selector.querySelectorAll( '.js-filter-chip ' ) ) as HTMLElement[];
		if ( chips.length ) {
			chips.forEach( chip => {
				chip.addEventListener( 'click', () => {
					chip.remove();
					this.apiFilterParams = { ...this.apiFilterParams, [ chip.getAttribute( 'data-name' ) ]: '' };
					this.clearFilterParams( this.pageQueryKey );
					this.filterDirectory();
					this.clearFilterOptions( chip.getAttribute( 'data-name' ) );
				} );
			} );
		}
	};
	debounceSearch( fn, delay = 200 ) {
		let timerId = null;
		return ( ...args ) => {
			clearTimeout( timerId );
			timerId = setTimeout(
				() =>
					fn( ...args ).then( () => {
						const searchIcon = document.querySelector( '.js-search-icon' ) as HTMLElement;
						const searchSpinner = document.querySelector( '.js-spinner-search' ) as HTMLElement;
						searchIcon.classList.remove( 'hidden' );
						searchSpinner.classList.add( 'hidden' );
						this.selector.scrollIntoView( {
							behavior: 'smooth',
							block: 'start',
							inline: 'nearest',
						} );
					} ),
				delay,
			);
		};
	}

	addEventForInnerDropdownItem = ( dropdown: HTMLElement ) => {
		const innerDropdownItems = Array.from( dropdown.querySelectorAll( '.inner-dropdown-item' ) ) as HTMLElement[];
		const innerDropdownInput = dropdown.querySelector( '.inner-dropdown-input ' ) as HTMLElement;
		const currentForm = dropdown.closest( 'form' ) as HTMLFormElement;
		const resultLabel = dropdown.querySelector( '.result-label' ) as HTMLElement;
		if ( innerDropdownItems.length ) {
			innerDropdownItems.forEach( item => {
				item.addEventListener( 'click', () => {
					const input = item.querySelector( 'input' ) as HTMLInputElement;
					input.checked = ! input.checked;
					item.classList.toggle( 'active' );
					currentForm.dispatchEvent( new Event( 'change', { bubbles: true } ) );
					const activeEle = Array.from(
						dropdown.querySelectorAll( '.inner-dropdown-item.active' ),
					) as HTMLElement[];
					const selectedLabelText = activeEle.map( item => item.dataset.label ).join( ', ' );
					resultLabel.innerHTML = selectedLabelText;
					if ( resultLabel.innerText !== '' ) {
						innerDropdownInput.classList.add( '!hidden' );
					} else {
						innerDropdownInput.classList.remove( '!hidden' );
					}
				} );
			} );
		}
	};

	renderDropdownSearch = listResults => {
		const searchItemTemplate = document.getElementById( 'search-item-template' ) as HTMLTemplateElement;
		const dropdownList = this.selector.querySelector( '.inner-dropdown-list ul' ) as HTMLElement;
		if ( listResults.length && dropdownList && searchItemTemplate ) {
			dropdownList.innerHTML = '';
			listResults.forEach( item => {
				const cloneTemplate = searchItemTemplate.content.cloneNode( true );
				const dropdownItem = cloneTemplate?.querySelector( '.inner-dropdown-item' ) as HTMLElement;
				const input = dropdownItem.querySelector( 'input' ) as HTMLInputElement;
				dropdownItem.setAttribute( 'id', item.term_id );
				dropdownItem.setAttribute( 'data-label', item.name );
				input.setAttribute( 'id', item.term_id );
				input.value = item.term_id;
				input.setAttribute( 'name', searchItemTemplate?.getAttribute( 'name' ) );
				dropdownItem.innerHTML += `${ item.name } ( ${ item.count } )`;
				dropdownList.appendChild( dropdownItem );
				this.addEventForInnerDropdownItem( dropdownItem );
			} );
		} else {
			dropdownList.innerHTML = '';
			const cloneTemplate = searchItemTemplate.content.cloneNode( true );
			const dropdownItem = cloneTemplate?.querySelector( '.inner-dropdown-item' ) as HTMLElement;
			dropdownItem.innerHTML = 'No options';
			dropdownList.appendChild( dropdownItem );
		}
	};
	memberShipFilter = ( currentCardFilter, cardShow ) => {
		currentCardFilter.classList.remove( 'active' );
		this.clearAllActiveFilter();
		const memberType = currentCardFilter.getAttribute( 'data-membership' );
		const dropdownFilter = Array.from( this.selector.querySelectorAll( '.dropdown-wrapper' ) ) as HTMLElement[];
		this.apiFilterParams = {};
		this.apiFilterParams[ 'member-ship' ] = [ memberType ];
		this.filterDirectory().then( () => {
			this.selector.scrollIntoView( {
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest',
			} );
		} );
		window.history.replaceState( null, '', `?member-ship=${ memberType }` );
		cardShow.classList.add( 'active' );
		dropdownFilter?.length &&
		dropdownFilter.forEach( item => {
			if ( memberType === 'ric' ) {
				item.dataset.name !== 'industry' && item.classList.add( 'hidden' );
			} else {
				item.classList.remove( 'hidden' );
			}
		} );
	};

	init() {
		this.getDataDropdownSearch();
		const dropdowns = Array.from( this.selector.querySelectorAll( '.dropdown-wrapper' ) ) as HTMLElement[];
		const tagFilterToggle = this.selector.querySelector( '.raise-tag-toggle' ) as HTMLElement;
		const sidebarForm = this.selector.querySelector( '.js-side-bar-filter-form' ) as HTMLFormElement;
		const sortForm = this.selector.querySelector( '.js-tag-filter-form' ) as HTMLFormElement;
		const mobileFilterToggle = this.selector.querySelector( '.mobile-filter-toggle' ) as HTMLElement;
		const mobileSortByToggle = this.selector.querySelector( '.mobile-sort-by-toggle' ) as HTMLElement;
		const closePopupToggleMobile = this.selector.querySelector( '.js-close-popup' ) as HTMLElement;
		const closePopupSortByToggleMobile = this.selector.querySelector( '.js-close-popup-sort-by' ) as HTMLElement;
		const mobileClearAllOptionController = this.selector.querySelector(
			'.js-clear-all-option-controller',
		) as HTMLElement;
		const mobileFilterController = this.selector.querySelector( '.js-mobile-filter-controller' ) as HTMLElement;
		const bfgInputSearch = document.querySelector( '.js-bfg-input-search' ) as HTMLInputElement;
		const clearSearchInput = document.querySelector( '.js-clear-search' ) as HTMLElement;
		const searchIcon = document.querySelector( '.js-search-icon' ) as HTMLElement;

		if ( bfgInputSearch ) {
			const onInput = this.debounceSearch( this.filterDirectory, 200 );
			const searchSpinner = document.querySelector( '.js-spinner-search' ) as HTMLElement;
			const InputQueryParam = this.urlParamMethod.getUrlParameter(this.searchQueryKey)
			InputQueryParam && InputQueryParam.length > 0 && (bfgInputSearch.value = InputQueryParam[0], this.apiFilterParams[ this.searchQueryKey ] = InputQueryParam[0])
			bfgInputSearch.addEventListener( 'keyup', ( e: Event ) => {
				const inputValue = e.target?.value;
				if ( inputValue ) {
					clearSearchInput.classList.add( 'active' );
					searchIcon.classList.add( 'active' );
				} else {
					clearSearchInput.classList.remove( 'active' );
					searchIcon.classList.remove( 'active' );
				}
				if ( inputValue && e.key === 'Enter' ) {
					// this.clearFilterParams( this.pageQueryKey );
					searchIcon.classList.add( 'hidden' );
					searchSpinner.classList.remove( 'hidden' );
					onInput( inputValue );
				}
				this.apiFilterParams[ this.searchQueryKey ] = inputValue;
				this.clearFilterParams( this.pageQueryKey );
				this.urlParamMethod.pushQueryParamsToUrl(this.searchQueryKey,inputValue)
			} );
		}
		if ( clearSearchInput ) {
			clearSearchInput.addEventListener( 'click', () => {
				bfgInputSearch.value = '';
				this.clearFilterParams( this.searchQueryKey );
				clearSearchInput.classList.remove( 'active' );
				bfgInputSearch.focus();
				this.clearFilterParams( this.pageQueryKey );
				this.filterDirectory();
				searchIcon.classList.remove( 'active' );
			} );
		}
		if ( dropdowns.length ) {
			dropdowns.forEach( dropdown => {
				const dropdownLabel = dropdown.querySelector( '.dropdown-label' ) as HTMLElement;
				dropdownLabel.addEventListener( 'click', () => {
					const innerDropdownLabel = dropdown.querySelector( '.inner-dropdown-label' ) as HTMLElement;
					const dropdownIcon = dropdown.querySelector( '.dropdown-icon' ) as HTMLElement;
					const dropdownOption = dropdown.querySelector( '.dropdown-option-wrapper' ) as HTMLElement;
					dropdownOption.classList.toggle( 'active' );
					dropdownIcon.classList.toggle( 'active' );
					const inputSearch = dropdown.querySelector( '.inner-dropdown-input' ) as HTMLInputElement;
					if ( innerDropdownLabel ) {
						innerDropdownLabel.addEventListener( 'click', ( e: MouseEvent ) => {
							if ( ( e.target as HTMLElement ).classList.contains( 'inner-dropdown-input' ) ) {
								return;
							}
							const innerDropdownList = dropdown.querySelector( '.inner-dropdown-list' ) as HTMLElement;
							const innerDropdownIcon = dropdown.querySelector( '.inner-dropdown-icon' ) as HTMLElement;
							const innerDropdownInput = dropdown.querySelector( '.inner-dropdown-input' ) as HTMLElement;
							innerDropdownLabel.classList.toggle( 'active' );
							innerDropdownList && innerDropdownList.classList.toggle( 'active' );
							innerDropdownIcon && innerDropdownIcon.classList.toggle( 'active' );
							innerDropdownInput && innerDropdownInput.focus();
							this.renderDropdownSearch( this.taxonomySearchData );
							inputSearch.value = '';
							this.addEventForInnerDropdownItem( dropdown );
						} );
					}
					if ( inputSearch ) {
						inputSearch.addEventListener( 'keyup', () => {
							if ( ! inputSearch?.value ) {
								this.renderDropdownSearch( this.taxonomySearchData );
							} else {
								const SearchResults = this.taxonomySearchData.filter( item =>
									item.name.toLowerCase().includes( inputSearch.value.toLowerCase() ),
								);
								this.renderDropdownSearch( SearchResults );
							}
						} );
					}
					this.handleExpandOptions( dropdown );
				} );
			} );
		}

		if ( sidebarForm ) {
			sidebarForm.addEventListener( 'change', async (e) => {
				let formData = new FormData(sidebarForm);
				let selectedData = formData.getAll(e.target.name);
				if(!selectedData || selectedData.length === 0){
					const getChipElm: HTMLElement = this.selector.querySelector(`.js-chip-container .js-filter-chip[data-name="${e.target.name}"]`)
					const url = new URL(window.location);
					url.searchParams.delete(e.target.name); // Remove specific key
					this.apiFilterParams = { ...this.apiFilterParams, [ e.target.name ]: '' };
					this.clearFilterParams( e.target.name );
					this.clearFilterOptions( e.target.name );
					getChipElm?.click()
				}else{
					await this.handleOptionChange( sidebarForm )
				}
			} );
		}
		if ( sortForm ) {
			sortForm.addEventListener( 'change', () => this.handleOptionChange( sortForm ) );
		}
		this.addEventClickDirectoryItem();

		if ( window.location.search ) {
			this.activeFilter(sidebarForm);
			this.activeFilterToggleMobile();
			this.filterDirectory();
		} else {
			this.filterDirectory();
		}
		if ( tagFilterToggle ) {
			tagFilterToggle.addEventListener( 'click', this.handleOpenTagFilter );
		}

		// Handle mobile filter
		if ( mobileFilterToggle ) {
			mobileFilterToggle.addEventListener( 'click', () =>
				this.handleOpenFilterPopupMobile( 'mobile-popup-filter' ),
			);
		}
		if ( mobileSortByToggle ) {
			mobileSortByToggle.addEventListener( 'click', () =>
				this.handleOpenFilterPopupMobile( 'mobile-popup-sort-by' ),
			);
		}
		if ( closePopupToggleMobile ) {
			closePopupToggleMobile.addEventListener( 'click', () =>
				this.handleClosePopupFilterMobile( 'mobile-popup-filter' ),
			);
		}
		if ( closePopupSortByToggleMobile ) {
			closePopupSortByToggleMobile.addEventListener( 'click', () =>
				this.handleClosePopupFilterMobile( 'mobile-popup-sort-by' ),
			);
		}
		if ( mobileClearAllOptionController ) {
			mobileClearAllOptionController.addEventListener( 'click', e => this.handleClearMobilePopupOption( e ) );
		}
		if ( mobileFilterController ) {
			mobileFilterController.addEventListener( 'click', e => {
				e.preventDefault();
				this.clearFilterParams( this.pageQueryKey );
				this.handleClosePopupFilterMobile( 'mobile-popup-filter' );
			} );
		}
		// handle RIC filter
		const ricMemberShipFilter = this.selector.querySelector( '.js-ric-member-ship-filter' ) as HTMLElement;
		const normalMembershipFilter = this.selector.querySelector( '.js-normal-membership-filter' ) as HTMLElement;

		if ( ricMemberShipFilter ) {
			ricMemberShipFilter.addEventListener( 'click', () =>
				this.memberShipFilter( ricMemberShipFilter, normalMembershipFilter ),
			);
		}
		if ( normalMembershipFilter ) {
			normalMembershipFilter.addEventListener( 'click', () =>
				this.memberShipFilter( normalMembershipFilter, ricMemberShipFilter ),
			);
		}
		if (
			this.urlParamMethod.getUrlParameter( 'member-ship' )?.length &&
			this.urlParamMethod.getUrlParameter( 'member-ship' )?.[ 0 ] === 'ric'
		) {
			const dropdownFilter = Array.from( this.selector.querySelectorAll( '.dropdown-wrapper' ) ) as HTMLElement[];
			// ricMemberShipFilter.classList.remove( 'active' );
			// normalMembershipFilter.classList.add( 'active' );
			dropdownFilter.forEach( item => item.dataset.name !== 'industry' && item.classList.add( 'hidden' ) );
		}
		tippy('[data-tippy-content]');

	}
}

export default DirectoryListing;
